//
// Log messages to the console.
function ANTelemetryLogger(telemetry, logToServer){

    AdsNinjaLogger.call(this);

    this.__telemetry        = telemetry;
    this.__logToServer      = logToServer;
    this.__canSendTelemetry = null;
}

ANTelemetryLogger.prototype             = Object.create(AdsNinjaLogger.prototype);
ANTelemetryLogger.prototype.constructor = AdsNinjaLogger;

//
// Logs to console with warn level.
ANTelemetryLogger.prototype.warn = function(message, data = {}, takeDataSnapshot = true){

    var logData = this.__getLogData(data, takeDataSnapshot);

    console.warn(
        `%c${this.DEFAULT_MESSAGE_PILL}`,
        `${this.DEFAULT_STYLE_PILL} ${this.DEFAULT_STYLE_PILL_WARN}`,
        message,
        logData
    );

    if(this.canSendTelemetry()){
    
        this.__telemetry.send('error', message, data);
    }
};

//
// Logs to console with error level. 
ANTelemetryLogger.prototype.error = function(message, data = {}, takeDataSnapshot = true){

    var logData = this.__getLogData(data, takeDataSnapshot);

    console.error(
        `%c${this.DEFAULT_MESSAGE_PILL}`,
        `${this.DEFAULT_STYLE_PILL} ${this.DEFAULT_STYLE_PILL_ERROR}`,
        message,
        logData
    );

    if(this.canSendTelemetry()){
    
        this.__telemetry.send('error', message, data);
    }
};

//
// Check if we can send telemetry.
ANTelemetryLogger.prototype.canSendTelemetry = function(){

    if(this.__canSendTelemetry !== null){

        return this.__canSendTelemetry;
    }

    return (this.__logToServer 
        && this.__telemetry
        && typeof this.__telemetry === 'object'
        && typeof this.__telemetry.send === 'function'
    );
};

window.ANTelemetryLogger = ANTelemetryLogger;